import React, { FC } from 'react';

import { useI18n } from 'Hooks';

import { Title404, Wrapper } from './styles';

const FourOhFour: FC = () => {
  const { t } = useI18n();

  return (
    <Wrapper>
      <Title404>404</Title404>
      {t('404.Title')}
    </Wrapper>
  );
};

export default FourOhFour;
